export const getPassengersByCount = (passengers) => {
    const totalPassengers =  passengers.length;
    return {totalPassengers};

};